<template>
  <div class="c-report-header">
    <el-breadcrumb class="header-breadcrumb" separator="/">
      <el-breadcrumb-item :to="{ path: '/pt/exercise-center' }">
        <span class="header-color">练习中心</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>{{this.textName ? '练习内容' : '练习报告'}}</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="header-title">
      <div class="header-title__left">
        <p class="left-line"/>
        <p class="left-text">
          <span class="text-bg">{{basicInfo.evaluate_name }}</span>
        </p>
      </div>
      <div class="header-title__right" >
        <div class="right-title">{{basicInfo.class_name}}</div>

        <el-dropdown @command="handleCommand" v-if="classList.length>1">
          <div class="right-content">
            <i class="change-class-icon"/>
            <span class="el-dropdown-link">
              切换班级
            </span>
          </div>
          <el-dropdown-menu slot="dropdown" >
            <el-dropdown-item :divided="index!=0" v-for="(item,index) in classList"
            :class="{active:item.class_name===basicInfo.class_name}"
            :key="`classList_${index}`" :command="item">{{item.class_name}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

      </div>
    </div>

    <div class="header-info">
      <p class="header-info__size">练习id：{{basicInfo.evaluate_id}}</p>
      <p class="header-info__size">
        练习教材：{{`${basicInfo.subject_name}-${basicInfo.textbook_name}`}}</p>
      <p class="header-info__size">练习人数：{{basicInfo.total_stu}}</p>
      <p class="header-info__size">创建人：{{basicInfo.creator}}</p>
      <p class="header-info__size">布置时间：{{basicInfo.create_time}}</p>

    </div>

  </div>
</template>

<script>
import { getClassListByBatchId } from '@/api/pt';

export default {
  name: 'ReportHeader',
  props: {
    basicInfo: {
      type: Object,
      default: () => {},
    },
    textName: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      classList: [],
      className: [],
    };
  },
  watch: {
    basicInfo() {
      this.gradeName = this.classList.filter(
        (item) => this.basicInfo.class_id === item.class_id,
      ) ?.[0].grade_name;
    },
  },
  computed: {
    // 防止变更处理
    classLen() {
      return `${this.className.length}个`;
    },
  },
  methods: {
    getClassListByBatchId() {
      const { batchId, schoolId } = this.$route.query;
      getClassListByBatchId({
        batch_id: batchId,
        school_id: schoolId,
      }).then(({ data }) => {
        this.classList = data || [];
      });
    },
    handleCommand(command) {
      this.$emit('changeClassByData', command);
    },
  },
  activated() {
    // this.getClassListByBatchId();
  },
  mounted() {
    this.getClassListByBatchId();
  },
};
</script>

<style lang="scss" scoped>
.c-report-header{
  height: 170px;
  background-color: #fff;
  margin-bottom: 8px;
  padding:22px 0 0 20px;
  box-sizing: border-box;
  .header-breadcrumb{
    height: 14px;
    font-size: 14px;
    font-family: 'PingFangSC-Regular', 'PingFang SC';
    font-weight: 400;
    line-height: 14px;
    .header-color{
      color:#1989FA;
    }
  }
  .header-title{
    display: flex;
    align-items: center;
    justify-content: space-between;
    &__left{
      display: flex;
      align-items: center;
      .left-line{
        margin:19px 0 20px 0;
        display: block;
        width: 3px;
        height: 16px;
        background: #1890FF;
        border-radius: 3px;
        margin-right: 8px;
      }
      .left-text{
        font-size: 18px;
        height: 25px;
        font-family: 'PingFangSC-Medium', 'PingFang SC';
        font-weight: 500;
        color: #000000;
        line-height: 25px;
        position: relative;
        &:after{
          content:'';
          position: absolute;
          width:100%;
          height:50%;
          left:0;
          bottom:3px;
          background:rgba(230, 162, 60, 0.2);
          border-radius: 16px;
        }
        .text-bg{
          position: relative;
          z-index: 2;
        }
      }
    }
    &__right{
      font-size: 16px;
      display: flex;
      align-items: center;
      margin-right: 20px;
      .right-title{
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
      }
      .right-content{
        display: flex;
        align-items: center;
        .el-icon-arrow-down {
          font-size: 14px;
        }
        .change-class-icon{
          display: inline-block;
          width: 16px;
          height:15px;
          background: url('~@/views/pt/images/change-class-icon.png');
          background-size:cover;
          margin:0 5px 0 22px;
        }
      }

    }
  }
  .mt-30{
    margin-top:15px;
  }
  .header-info{
    display: flex;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(48, 49, 51, 0.6);
    &__size{
      margin-right: 30px;
    }
  }
}
.el-dropdown-link {
  cursor: pointer;
  color: #1989FA;
}
.active{
  color: #1989FA;
}
</style>
